import React, {Component} from 'react';
import {connect} from 'react-redux';
import {unbundleBatch, prepareBatch} from '../mytasks/myTasks.action';
import Confirm from '../popup/ConfirmActionPopup.component';
import {Button, ButtonType} from 'components/common/Button.component';


export class BatchButtons extends Component {

    constructor() {
        super();
        this.state = {
            displayConfirm: false

        };
        this.unbundleTasks = this.unbundleTasks.bind(this);
        this.sign = this.sign.bind(this);
        this.hideConfirm = this.hideConfirm.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
    }


    unbundleTasks() {
        if (this.props.batch.documents.length > 1)
            this.setState({
                displayConfirm: true
            });
        else
            this.props.unbundleBatch(this.props.batch.id, this.props.batch.version);
    };

    hideConfirm() {
        this.setState({
            displayConfirm: false
        });
    }

    confirmDelete() {
        this.props.unbundleBatch(this.props.batch.id, this.props.batch.version);
        this.hideConfirm();
    }


    sign() {
        if (this.props.okCallback)
            this.props.okCallback();
        this.props.prepareBatch(this.props.batch.id, this.props.batch.version).then((batch) => {
            //batch can be undefined
            if (batch?.redirectUrl) {
                try {
                    const url = new URL(batch.redirectUrl);
                    if (url.protocol === 'https:' || url.protocol === 'http:') {
                        window.location.href = url.href;
                    }
                } catch {
                    // redirectUrl is not a valid URL, ignore
                }
            }
        });
    };

    render() {
        return (
            <div>
                {this.state.displayConfirm &&
                    <Confirm translate={this.props.translate}
                             message={this.props.translate("myTasks.confirmCancelBatch")}
                             handleAction={this.confirmDelete}
                             closeCallback={this.hideConfirm}/>
                }
                <div className="d-flex justify-content-start gap-8">
                    <Button
                        type={ButtonType.PRIMARY}
                        onClick={this.sign}
                        text={this.props.translate("myTasks.continueToSign")}/>
                    <Button
                        type={ButtonType.SECONDARY}
                        onClick={this.unbundleTasks}
                        text={this.props.translate("myTasks.removeBundle")}/>
                </div>
            </div>
        );
    }

}

const mapBatchButtonsStateToProps = function (store) {
    return {};
};
const connected = connect(mapBatchButtonsStateToProps, {unbundleBatch, prepareBatch})(BatchButtons);

export default connected;